import { NOT_FOUND } from 'redux-first-router';
import * as types from './../actions/actionTypes';


export default (state = 'Header', action = {}) => {
    const lang = (
        action.payload || {}
    ).language || 'de';

    switch (action.type) {
        default:
            if (action.type.indexOf('NAVIGATED') !== -1) {
                return components[action.type] || 'Header';
            }
            return state;
    }
};

const components = {

    [types.NAVIGATED_TO_HOME]: 'Header',
    [types.NAVIGATED_TO_SEWPAT_GALLERY]: 'SewpatGallery',

    [types.NAVIGATED_TO_TOPCATEGORIES]: 'PatternCategories',
    [types.NAVIGATED_TO_SUBCATEGORIES]: 'PatternCategories',
    [types.NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY]: 'PatternCategories',
    [types.NAVIGATED_TO_SEWPAT_PATTERN_GALLERY]: 'PatternCategories',
    [types.NAVIGATED_TO_NEWEST_PATTERNGALLERY]: 'PatternCategories',
    [types.NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY]: 'PatternCategories',
    [types.NAVIGATED_TO_SEARCHGALLERY]: 'PatternCategories',

    [types.NAVIGATED_TO_SINGLE_PATTERN_VIEW]: 'Header',

    [types.NAVIGATED_TO_SEWPAT_VIEW]: 'SingleSewpatView',

    [NOT_FOUND]: 'NotFound',

    [types.NAVIGATED_TO_LOVED_PATTERNS]: 'FavoritesGallery',
    [types.NAVIGATED_TO_PATTERNS_FROM_DESIGNER]: 'PatternCategories',
};

export const getHeader = function getHeader(state) {
    return state.header;
};




// WEBPACK FOOTER //
// ./src/reducers/header.js